import { Component, Inject, OnInit } from '@angular/core';
import {  MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicStyleLoaderService } from '../../utilities/dynamic-style-loader';

@Component({
    selector: 'my-account-edit-child-address',
    templateUrl: './edit-child-address.component.html',
    styleUrls: ['./edit-child-address.component.scss'],
    standalone: false
})
export class EditChildAddressComponent implements OnInit {
  dialogData:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dynamicStyleLoader: DynamicStyleLoaderService) {
    this.dialogData = data.parentInstance;
   }  
 
  ngOnInit(): void {
    this.dynamicStyleLoader.focusCloseButton('mob-focus-phone','desktop-focus-phone');
  }

}
 

